export default __webpack_public_path__ + "static/media/qrcode.408483a0.svg";